import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { MenuItemComponent } from '@components/menu-item/menu-item.component';
import { SidebarSearchComponent } from '@components/sidebar-search/sidebar-search.component';
import { InfoBoxComponent } from '@components/info-box/info-box.component';
import { SmallBoxComponent } from '@components/small-box/small-box.component';
import { ContentHeaderComponent } from '@components/content-header/content-header.component';
import { OverlayLoadingComponent } from '@components/overlay-loading/overlay-loading.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    MenuItemComponent,
    SidebarSearchComponent,
    InfoBoxComponent,
    SmallBoxComponent,
    ContentHeaderComponent,
    OverlayLoadingComponent,
  ],
  exports: [
    MenuItemComponent,
    SidebarSearchComponent,
    InfoBoxComponent,
    SmallBoxComponent,
    ContentHeaderComponent,
    OverlayLoadingComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
  ]
})
export class DashboardComponentsModule { }
